import * as React from "react";

export const PlusIcon = (props: React.SVGProps<SVGSVGElement>) => (
    <svg {...props} width="36" height="36" viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g id="icons/new/arrow-right">
            <path id="Combined Shape" fillRule="evenodd" clipRule="evenodd" d="M18 29C18.4142 29 18.75 28.6642 18.75 28.25V17.75H29.25C29.6642 17.75 30 17.4142 30 17C30 16.5858 29.6642 16.25 29.25 16.25H18.75V5.75C18.75 5.33579 18.4142 5 18 5C17.5858 5 17.25 5.33579 17.25 5.75V16.25H6.75C6.33579 16.25 6 16.5858 6 17C6 17.4142 6.33579 17.75 6.75 17.75H17.25V28.25C17.25 28.6642 17.5858 29 18 29Z" fill="#333333"/>
        </g>
    </svg>
);
